/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Quick_Scan_RecentInputs */

const vi_warehouse_quick_scan_recent = /** @type {(inputs: Warehouse_Quick_Scan_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vừa nhập`)
};

/**

* @param {Warehouse_Quick_Scan_RecentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_quick_scan_recent = /** @type {((inputs?: Warehouse_Quick_Scan_RecentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Quick_Scan_RecentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_quick_scan_recent(inputs)
});